'use client'

import { toast } from 'sonner'

/**
 * Ambiguous paste — offer convert vs keep as inline text (4s auto-dismiss).
 */
export function showPasteSuggestion({ onConvert, onKeep }) {
  const id = toast.custom(
    (t) => (
      <div
        className="nb-paste-suggestion"
        role="status"
        data-visible={t.visible}
      >
        <p className="nb-paste-suggestion__text">
          Paste detected as plain text. Convert into structured block items?
        </p>
        <div className="nb-paste-suggestion__actions">
          <button
            type="button"
            className="nb-paste-suggestion__btn nb-paste-suggestion__btn--primary"
            onClick={() => {
              toast.dismiss(id)
              onConvert?.()
            }}
          >
            Convert
          </button>
          <button
            type="button"
            className="nb-paste-suggestion__btn"
            onClick={() => {
              toast.dismiss(id)
              onKeep?.()
            }}
          >
            Keep as text
          </button>
        </div>
      </div>
    ),
    { duration: 4000, position: 'bottom-center' },
  )
  return id
}
